define([
    'text!WebCommon/component/image-link-slick.html',
    'WebCommon/utils',
    'WebCommon/mixin/slick',
    'css!WebCommon/component/image-link-slick.css'
], function(
    tpl,
    Utils,
    SlickMixin
){
    return {
        template: tpl,
        mixins: [SlickMixin],
        methods: {
            genCdnImageUrl: Utils.genCdnImageUrl
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ../common/component/image-link-slick.js
// module id = 102
// module chunks = 1 2 3 4